import React from "react";

export function NRSLogo({ size = 28, mono = false, className = "" }) {
  // Mark: stylized "M" inside a rounded square.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="mdrflow-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={mono ? "#FFFFFF" : "#1D4ED8"} />
          <stop offset="1" stopColor={mono ? "#FFFFFF" : "#1E3A8A"} />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="38" height="38" rx="8" fill={mono ? "transparent" : "url(#mdrflow-grad)"} stroke={mono ? "#FFFFFF" : "none"} strokeWidth={mono ? "1.5" : "0"} />
      {/* Brand mark */}
      <path
        d="M10 28 V12 H15 L20 19 L25 12 H30 V28 H25 V20 L20 27 L15 20 V28 Z"
        fill={mono ? "#FFFFFF" : "#FFFFFF"}
      />
      {/* compliance dot — represents audit/checkpoint */}
      <circle cx="32" cy="11" r="2.5" fill={mono ? "#FFFFFF" : "#60A5FA"} />
    </svg>
  );
}

export function EuropeanFlag({ size = 28, className = "" }) {
  const stars = Array.from({ length: 12 }, (_, index) => {
    const centerAngle = ((index * 30 - 90) * Math.PI) / 180;
    const starCx = 18 + 7.2 * Math.cos(centerAngle);
    const starCy = 12 + 7.2 * Math.sin(centerAngle);
    const points = Array.from({ length: 10 }, (_, pointIndex) => {
      const angle = centerAngle + (pointIndex * Math.PI) / 5;
      const radius = pointIndex % 2 === 0 ? 1.45 : 0.62;
      return `${starCx + radius * Math.cos(angle)},${starCy + radius * Math.sin(angle)}`;
    }).join(" ");
    return (
      <polygon
        key={index}
        points={points}
        fill="#FFCC00"
      />
    );
  });

  return (
    <svg
      width={size}
      height={size * (2 / 3)}
      viewBox="0 0 36 24"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="36" height="24" rx="2" fill="#003399" />
      {stars}
    </svg>
  );
}

export function NRSWordmark({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 font-sans text-xs tracking-tight font-bold ${className}`}>
      <span>MDRFlow</span>
      <EuropeanFlag size={28} />
    </span>
  );
}
